import styled from 'styled-components';

const THead = styled.thead``;

export { THead };
